export const inlineButtonStyle = {
  padding: '4px',
  minHeight: 'fit-content',
  height: 'fit-content',
};
